import React, {Component} from "react";
import {Button, Card, DatePicker, Input, List, Modal, Select, Skeleton, Switch} from "antd";
import {getAllPayItems, getPayItemsByCategory, getPayItemsInRange, searchPayItems, getDailySpending} from "../util/APIUtils";
import {convertToLocalFormat} from "../util/utils";
import "./PayItemListOverview.scss";
import moment from "moment";
import 'moment-timezone';
import {dateFormat} from "../constants";
import {getUserTimezone} from '../util/timezone';
import {
    BookOutlined,
    CarOutlined,
    CoffeeOutlined,
    DollarOutlined,
    GiftOutlined,
    HomeOutlined,
    MedicineBoxOutlined,
    PhoneOutlined,
    ShoppingCartOutlined,
    ThunderboltOutlined
} from "@ant-design/icons";
import NewChitiItem from "./NewChitiItem";
import {Bar, BarChart, CartesianGrid, Cell, ResponsiveContainer, Tooltip, XAxis, YAxis} from 'recharts';

const {Meta} = Card;
const {Option} = Select;

class PayItemListOverview extends Component {
    state = {
        initLoading: true,
        loading: false,
        data: [],
        list: [],
        count: 0,
        visible: false,
        confirmLoading: false,
        selectedItem: null,
        selectedItems: [],
        overview: {},
        total: {},
        bottom: 10,
        date: moment().format(dateFormat),
        dateTo: moment().format(dateFormat),
        sortBy: 'date-desc',
        keyword: '',
        dailySpending: [],
        chartOrientation: 'horizontal'
    };

    componentDidMount() {
        this._isMounted = true;
        this.loadPollList();
        this.loadDailySpending();
    }

    componentDidUpdate(prevProps) {
        // React to search keyword pushed from Dashboard (also fires when searchVersion bumps with same keyword)
        if (prevProps.searchKeyword !== this.props.searchKeyword ||
            prevProps.searchVersion !== this.props.searchVersion) {
            this.setState(
                { keyword: this.props.searchKeyword || '', initLoading: true, loading: false, data: [], list: [], count: 0 },
                () => this.loadPollList()
            );
        }
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    loadDailySpending(date) {
        const d = date || this.state.date;
        if (this.props.category) return; // not needed in category detail view
        getDailySpending(d).then(response => {
            if (this._isMounted) this.setState({ dailySpending: response });
        }).catch(() => {});
    }

    loadPollList() {
        const category = this.getCategory();
        let promise = category
            ? getPayItemsByCategory(
                this.props.date ? moment(this.props.date).format(dateFormat) : moment(this.state.date).format(dateFormat),
                this.props.dateTo ? moment(this.props.dateTo).format(dateFormat) : moment(this.state.dateTo).format(dateFormat),
                category, this.state.count, 10)
            : this.state.keyword
                ? searchPayItems(this.state.keyword, this.state.count, 10)
                : getPayItemsInRange(this.state.date, this.state.dateTo, this.state.count, 10);
        if (!promise) {
            return;
        }
        promise.then(response => {
            if (!this._isMounted) return;
            const data = this.state.data.concat(response);
            const total = this.getTotal(data);
            const count = this.state.count + 1;
            this.setState(
                {
                    data,
                    list: data,
                    total: total,
                    loading: false,
                    count: count
                },
                () => {
                    window.dispatchEvent(new Event("resize"));
                }
            );
        });
        this.setState({
            initLoading: false
        });
    }

    getCategory() {
        const category = this.props.category;
        return category;
    }

    onLoadMore = () => {
        this.setState({
            loading: true,
            list: this.state.data.concat(
                [...new Array(5)].map(() => ({loading: true, name: {}}))
            )
        });
        this.loadPollList();
    };

    onClick = item => {
        console.log("PayItemListOverview - Expense clicked: ", item);
        this.showModal(item);
    };

    showModal = item => {
        console.log("PayItemListOverview - Opening modal, visible will be set to true");
        this.setState({
            visible: true,
            selectedItem: item
        }, () => {
            console.log("PayItemListOverview - Modal state updated, visible:", this.state.visible);
        });
    };

    showCreateModal = () => {
        this.setState({
            visible: true,
            selectedItem: null
        });
    };


    handleOk = () => {
        console.log('handleOk called, onUpdate prop:', this.props.onUpdate);
        this.setState({
            initLoading: true,
            loading: false,
            data: [],
            list: [],
            count: 0,
            visible: false,
            confirmLoading: false,
            selectedItem: null
        }, () => {
            this.loadPollList();
            // Notify parent to reload if it's ChitiOverview
            if (this.props.onUpdate) {
                console.log('Calling onUpdate callback');
                this.props.onUpdate();
            }
            // Dispatch event for any listening components
            window.dispatchEvent(new Event('expenseUpdated'));
        });
    };

    handleCancel = () => {
        console.log("PayItemListOverview - Closing modal, visible will be set to false");
        this.setState({
            visible: false
        }, () => {
            console.log("PayItemListOverview - Modal closed, visible:", this.state.visible);
        });
    };

    handleCategoryChange = selectedItems => {
        this.setState({
            selectedItems,
            initLoading: true,
            loading: false,
            data: [],
            list: [],
            count: 0,
            visible: false,
            confirmLoading: false,
            selectedItem: null,

        });
    };

    handleSearchChange = (e) => {
        this.setState({ keyword: e.target.value });
    }

    handleSearch = () => {
        this.setState({ initLoading: true, loading: false, data: [], list: [], count: 0 }, () => {
            this.loadPollList();
        });
    }

    handleFromDateChange = (date) => {
        if (!date) return;
        const datef = moment(date).format(dateFormat);
        this.setState({ date: datef, keyword: '', initLoading: true, loading: false, data: [], list: [], count: 0 }, () => {
            this.loadPollList();
        });
    }

    handleToDateChange = (date) => {
        if (!date) return;
        const datef = moment(date).format(dateFormat);
        this.setState({ dateTo: datef, keyword: '', initLoading: true, loading: false, data: [], list: [], count: 0 }, () => {
            this.loadPollList();
        });
    }

    handleQuickDay = (offset) => {
        // offset 0 = today, -1 = prev from current, +1 = next from current
        const base = offset === 0 ? moment() : moment(this.state.date).add(offset, 'days');
        const datef = base.format(dateFormat);
        this.setState({ date: datef, dateTo: datef, keyword: '', initLoading: true, loading: false, data: [], list: [], count: 0 }, () => {
            this.loadPollList();
            this.loadDailySpending(datef);
        });
    }

    handleInputDateChange = (date) => {
        if (!date) return; // Ignore if date is cleared
        const datef = moment(date).format(dateFormat);
        console.log("date: " + datef);

        this.setState({
            date: datef,
            initLoading: true,
            loading: false,
            data: [],
            list: [],
            count: 0,
            visible: false,
            confirmLoading: false,
            selectedItem: null
        }, () => {
            this.loadPollList();
            this.loadDailySpending(datef);
        });

    }

    getTotal = (data) => {
        let total = data.reduce(function (total, b) {
            return total + b.price;
        }, 0);
        return total;
    }

    getCategoryIcon = (category) => {
        const categoryMap = {
            'Food': <CoffeeOutlined style={{ fontSize: '24px', color: '#ff7875' }} />,
            'Shopping': <ShoppingCartOutlined style={{ fontSize: '24px', color: '#ffa940' }} />,
            'Housing': <HomeOutlined style={{ fontSize: '24px', color: '#597ef7' }} />,
            'Transportation': <CarOutlined style={{ fontSize: '24px', color: '#73d13d' }} />,
            'Healthcare': <MedicineBoxOutlined style={{ fontSize: '24px', color: '#ff85c0' }} />,
            'Education': <BookOutlined style={{ fontSize: '24px', color: '#9254de' }} />,
            'Entertainment': <GiftOutlined style={{ fontSize: '24px', color: '#ffc53d' }} />,
            'Utilities': <ThunderboltOutlined style={{ fontSize: '24px', color: '#36cfc9' }} />,
            'Phone': <PhoneOutlined style={{ fontSize: '24px', color: '#5cdbd3' }} />,
        };
        return categoryMap[category] || <DollarOutlined style={{ fontSize: '24px', color: '#95de64' }} />;
    }

    getSortedList = (list) => {
        const { sortBy } = this.state;
        const sortedList = [...list];

        switch(sortBy) {
            case 'amount-high':
                return sortedList.sort((a, b) => b.price - a.price);
            case 'amount-low':
                return sortedList.sort((a, b) => a.price - b.price);
            case 'category-asc':
                return sortedList.sort((a, b) => (a.category || '').localeCompare(b.category || ''));
            case 'category-desc':
                return sortedList.sort((a, b) => (b.category || '').localeCompare(a.category || ''));
            case 'date-desc':
                return sortedList.sort((a, b) => moment(b.tradingDate).valueOf() - moment(a.tradingDate).valueOf());
            case 'date-asc':
                return sortedList.sort((a, b) => moment(a.tradingDate).valueOf() - moment(b.tradingDate).valueOf());
            default:
                return sortedList.sort((a, b) => moment(b.tradingDate).valueOf() - moment(a.tradingDate).valueOf());
        }
    }

    render() {
        const {
            initLoading,
            loading,
            list,
            visible,
            total,
            dailySpending,
        } = this.state;
        const { chartOrientation } = this.state;

        console.log("PayItemListOverview render - visible:", visible, "selectedItem:", this.state.selectedItem);

        const category = this.getCategory();
        const loadMore =
            !initLoading && !loading && list.length > 0 ? (
                <div style={{ textAlign: "center", marginTop: 24 }}>
                    <Button type="dashed" onClick={this.onLoadMore} size="large">
                        Load more
                    </Button>
                </div>
            ) : null;
        const totalSa = !category
            ? `Total ${moment(this.state.date).format('MMM D')} – ${moment(this.state.dateTo).format('MMM D, YYYY')}`
            : `Total ${moment(this.props.date).format('MMMM YYYY')}`;
        const totalPrice = convertToLocalFormat(total, 0);
        const sortedList = this.getSortedList(list);

        return (
            <div style={{ background: '#f5f7fa', minHeight: '100vh', paddingBottom: '80px' }}>
                {/* Header */}
                {!category && (
                    <div style={{
                        background: 'linear-gradient(135deg, #1890ff 0%, #096dd9 100%)',
                        padding: '24px',
                        color: 'white',
                        borderRadius: '16px',
                        boxShadow: '0 4px 20px rgba(24, 144, 255, 0.3)',
                        margin: '16px'
                    }}>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', marginBottom: '16px' }}>
                            <div style={{ display: 'flex', gap: '8px' }}>
                                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                                    <span style={{ fontSize: '12px', opacity: 0.8 }}>From:</span>
                                    <DatePicker
                                        value={moment(this.state.date)}
                                        format="MMM DD YYYY"
                                        onChange={this.handleFromDateChange}
                                        size="large"
                                        allowClear={false}
                                        inputReadOnly
                                        style={{ borderRadius: '12px' }}
                                    />
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                                    <span style={{ fontSize: '12px', opacity: 0.8 }}>To:</span>
                                    <DatePicker
                                        value={moment(this.state.dateTo)}
                                        format="MMM DD YYYY"
                                        onChange={this.handleToDateChange}
                                        size="large"
                                        allowClear={false}
                                        inputReadOnly
                                        style={{ borderRadius: '12px' }}
                                    />
                                </div>
                            </div>

                            {/* Quick day selector — compact, left-aligned */}
                            <div style={{ display: 'flex', gap: '6px' }}>
                                {[
                                    { label: '‹ Prev', offset: -1 },
                                    { label: 'Today', offset: 0 },
                                    { label: 'Next ›', offset: 1 },
                                ].map(({ label, offset }) => {
                                    const isActive = offset === 0
                                        ? moment(this.state.date).isSame(moment(), 'day')
                                        : false;
                                    return (
                                        <button
                                            key={offset}
                                            onClick={() => this.handleQuickDay(offset)}
                                            style={{
                                                padding: '3px 12px',
                                                borderRadius: '8px',
                                                border: isActive ? '1.5px solid #fff' : '1.5px solid rgba(255,255,255,0.35)',
                                                background: isActive ? 'rgba(255,255,255,0.22)' : 'transparent',
                                                color: 'white',
                                                fontWeight: isActive ? 700 : 400,
                                                fontSize: '11px',
                                                cursor: 'pointer',
                                                transition: 'all 0.2s',
                                                letterSpacing: '0.2px',
                                                whiteSpace: 'nowrap',
                                            }}
                                        >
                                            {label}
                                        </button>
                                    );
                                })}
                            </div>
                        </div>

                        <div style={{ fontSize: '15px', opacity: 0.95, marginBottom: '12px', fontWeight: 500, letterSpacing: '0.5px' }}>
                            {moment(this.state.date).format('MMM D')} – {moment(this.state.dateTo).format('MMM D, YYYY')}
                        </div>
                        <div style={{ fontSize: '48px', fontWeight: 800, letterSpacing: '-2px' }}>
                            ${totalPrice}
                        </div>
                        <div style={{ fontSize: '13px', opacity: 0.85, marginTop: '8px' }}>Total Spending</div>
                    </div>
                )}

                {/* Sort */}
                {!category && (
                    <div style={{ padding: '12px 16px' }}>
                        <Select
                            value={this.state.sortBy}
                            onChange={(value) => this.setState({ sortBy: value })}
                            style={{ width: '100%' }}
                            size="large"
                        >
                            <Option value="amount-high">Amount: High to Low</Option>
                            <Option value="amount-low">Amount: Low to High</Option>
                            <Option value="date-desc">Date: Newest First</Option>
                            <Option value="date-asc">Date: Oldest First</Option>
                            <Option value="category-asc">Category: A to Z</Option>
                            <Option value="category-desc">Category: Z to A</Option>
                        </Select>
                    </div>
                )}


                {/* Expense List */}
                <div style={{ padding: '12px', background: '#fff', margin: '16px', borderRadius: '16px', boxShadow: '0 2px 12px rgba(0,0,0,0.06)' }}>
                    <List
                        loading={initLoading}
                        loadMore={loadMore}
                        dataSource={sortedList}
                        locale={{ emptyText: 'No expenses yet' }}
                        renderItem={item => (
                            <List.Item
                                style={{ padding: 0, marginBottom: '8px', border: 'none' }}
                                onClick={() => {
                                    if (!item.loading) {
                                        console.log("List.Item clicked, calling onClick with item:", item);
                                        this.onClick(item);
                                    }
                                }}
                            >
                                <div
                                    style={{
                                        width: '100%',
                                        padding: '12px',
                                        borderRadius: '8px',
                                        background: '#fafafa',
                                        cursor: 'pointer',
                                        transition: 'background 0.2s'
                                    }}
                                    onMouseEnter={(e) => e.currentTarget.style.background = '#f0f0f0'}
                                    onMouseLeave={(e) => e.currentTarget.style.background = '#fafafa'}
                                >
                                    <Skeleton loading={item.loading} active avatar>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                            {/* Icon */}
                                            <div style={{
                                                width: '40px',
                                                height: '40px',
                                                borderRadius: '50%',
                                                background: '#fff',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                flexShrink: 0
                                            }}>
                                                {this.getCategoryIcon(item.category)}
                                            </div>
                                            
                                            {/* Content */}
                                            <div style={{ flex: 1, minWidth: 0 }}>
                                                {/* ...existing content... */}
                                                <div style={{
                                                    display: 'flex', 
                                                    justifyContent: 'space-between',
                                                    alignItems: 'center',
                                                    marginBottom: '2px'
                                                }}>
                                                    <span style={{ 
                                                        fontSize: '15px', 
                                                        fontWeight: 600,
                                                        color: '#262626'
                                                    }}>
                                                        {item.description || item.category}
                                                    </span>
                                                    <span style={{ 
                                                        fontSize: '16px', 
                                                        fontWeight: 700,
                                                        color: '#262626'
                                                    }}>
                                                        ${convertToLocalFormat(item.price, 0)}
                                                    </span>
                                                </div>
                                                <div style={{ 
                                                    fontSize: '13px', 
                                                    color: '#8c8c8c'
                                                }}>
                                                    {moment(item.tradingDate).tz(getUserTimezone()).format('MMM DD, YYYY')}
                                                    {item.store && (
                                                        <span style={{ marginLeft: '8px' }}>· {item.store}</span>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </Skeleton>
                                </div>
                            </List.Item>
                        )}
                    />
                </div>

                {/* Daily Chart */}
                {!category && dailySpending.length > 0 && (
                    <div style={{ padding: '16px 20px 24px', background: '#fff', borderTop: '1px solid #f0f0f0' }}>
                        {/* Chart header with switch */}
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
                            <div style={{ fontSize: '14px', fontWeight: 600, color: '#262626' }}>
                                Daily Spending
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <span style={{ fontSize: '12px', color: '#8c8c8c' }}>
                                    {chartOrientation === 'horizontal' ? 'Horizontal' : 'Vertical'}
                                </span>
                                <Switch
                                    checked={chartOrientation === 'horizontal'}
                                    onChange={(checked) => this.setState({ chartOrientation: checked ? 'horizontal' : 'vertical' })}
                                    checkedChildren="H"
                                    unCheckedChildren="V"
                                    size="small"
                                />
                            </div>
                        </div>

                        {chartOrientation === 'vertical' ? (
                            <ResponsiveContainer width="100%" height={200}>
                                <BarChart
                                    data={dailySpending.map(item => ({
                                        date: moment(item.date).tz(getUserTimezone()).format('D'),
                                        amount: item.total
                                    }))}
                                >
                                    <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" vertical={false} />
                                    <XAxis dataKey="date" tick={{ fontSize: 11 }} axisLine={false} tickLine={false} />
                                    <YAxis tick={{ fontSize: 11 }} axisLine={false} tickLine={false} width={45} tickFormatter={(v) => `$${v}`} />
                                    <Tooltip formatter={(value) => [`$${convertToLocalFormat(value, 0)}`, 'Amount']} />
                                    <Bar dataKey="amount" fill="#1890ff" radius={[6, 6, 0, 0]}>
                                        {dailySpending.map((entry, index) => {
                                            const isToday = moment(entry.date).tz(getUserTimezone()).isSame(moment().tz(getUserTimezone()), 'day');
                                            return <Cell key={`cell-${index}`} fill={isToday ? '#ff4d4f' : '#1890ff'} />;
                                        })}
                                    </Bar>
                                </BarChart>
                            </ResponsiveContainer>
                        ) : (
                            <ResponsiveContainer width="100%" height={dailySpending.length * 36 + 40}>
                                <BarChart
                                    data={dailySpending.map(item => ({
                                        date: moment(item.date).tz(getUserTimezone()).format('MMM D'),
                                        amount: item.total
                                    }))}
                                    layout="vertical"
                                >
                                    <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" horizontal={false} />
                                    <XAxis type="number" tick={{ fontSize: 11 }} axisLine={false} tickLine={false} tickFormatter={(v) => `$${v}`} />
                                    <YAxis type="category" dataKey="date" tick={{ fontSize: 11 }} axisLine={false} tickLine={false} width={48} />
                                    <Tooltip formatter={(value) => [`$${convertToLocalFormat(value, 0)}`, 'Amount']} />
                                    <Bar dataKey="amount" fill="#1890ff" radius={[0, 6, 6, 0]}>
                                        {dailySpending.map((entry, index) => {
                                            const isToday = moment(entry.date).tz(getUserTimezone()).isSame(moment().tz(getUserTimezone()), 'day');
                                            return <Cell key={`cell-${index}`} fill={isToday ? '#ff4d4f' : '#1890ff'} />;
                                        })}
                                    </Bar>
                                </BarChart>
                            </ResponsiveContainer>
                        )}
                    </div>
                )}

                {/* Modal */}
                {visible && (
                    <Modal
                        title={this.state.selectedItem
                            ? <span style={{ fontSize: '17px', fontWeight: 700 }}>Edit Expense</span>
                            : <span style={{ fontSize: '17px', fontWeight: 700 }}>New Expense</span>
                        }
                        open={visible}
                        visible={visible}
                        onCancel={this.handleCancel}
                        footer={null}
                        width="92%"
                        style={{ maxWidth: '480px', top: 24 }}
                        bodyStyle={{ padding: '20px 24px 24px' }}
                        destroyOnClose={true}
                        centered
                    >
                        <NewChitiItem
                            item={this.state.selectedItem}
                            closeModal={this.handleOk}
                        />
                    </Modal>
                )}
            </div>
        );
    }
}

export default PayItemListOverview;
